/**
 * atoms.tsx — Componentes atômicos visuais do site institucional Nectaris
 * Exporta componentes React compatíveis com react-refresh.
 * Hooks em hooks.ts
 */

/* ============================================================
   LOGO MARK — hexágono N existente (app Órbita)
   ============================================================ */
interface LogoMarkProps {
  size?: number;
  className?: string;
}

export function LogoMark({ size = 30, className }: LogoMarkProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={className}
    >
      <polygon
        points="60,7 105.9,33.5 105.9,86.5 60,113 14.1,86.5 14.1,33.5"
        stroke="#F0EFE9"
        strokeWidth="8"
        strokeLinejoin="round"
        fill="none"
      />
      <line x1="41" y1="81" x2="41" y2="39" stroke="#F0EFE9" strokeWidth="12.5" strokeLinecap="round" />
      <line x1="41" y1="39" x2="79" y2="81" stroke="#F0EFE9" strokeWidth="12.5" strokeLinecap="round" strokeLinejoin="round" />
      <line x1="79" y1="81" x2="79" y2="39" stroke="#F0EFE9" strokeWidth="12.5" strokeLinecap="round" />
      <circle cx="79" cy="39" r="8" fill="#E0A43B" />
    </svg>
  );
}

/* ============================================================
   NECTARIS LOGO MARK — versão do site institucional Claude Design
   Versão "dark on light": traços escuros (#0B1B2B), ponto âmbar
   Versão "light on dark": traços brancos, ponto âmbar
   ============================================================ */
interface NectarisLogoMarkProps {
  size?: number;
  /** "dark" = traços brancos (para fundo escuro) | "light" = traços escuros (para nav claro) */
  variant?: "dark" | "light";
  className?: string;
}

export function NectarisLogoMark({ size = 44, variant = "light", className }: NectarisLogoMarkProps) {
  const stroke = variant === "light" ? "#0B1B2B" : "#FFFFFF";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={className}
    >
      {/* Hexágono */}
      <polygon
        points="60,7 105.9,33.5 105.9,86.5 60,113 14.1,86.5 14.1,33.5"
        stroke={stroke}
        strokeWidth="8"
        strokeLinejoin="round"
        fill="none"
      />
      {/* N traço esquerdo */}
      <line x1="41" y1="81" x2="41" y2="39" stroke={stroke} strokeWidth="12.5" strokeLinecap="round" />
      {/* N diagonal */}
      <line x1="41" y1="39" x2="79" y2="81" stroke={stroke} strokeWidth="12.5" strokeLinecap="round" strokeLinejoin="round" />
      {/* N traço direito */}
      <line x1="79" y1="81" x2="79" y2="39" stroke={stroke} strokeWidth="12.5" strokeLinecap="round" />
      {/* Ponto âmbar */}
      <circle cx="79" cy="39" r="8" fill="#E0A43B" />
    </svg>
  );
}
